// Copyright ©️ 2026 eVolve MEP, LLC

import { type TaskTimeEntry, useEvolveDelete } from '@evolvemep/api-ts';
import { Card, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';

import { VariableTrackingModal } from 'components/Mantine/Modals/VariableTrackingModal';
import { validateUserNameOrEmail } from 'helpers/userHelpers';
import { TimeEntry } from 'modules/Shop/TimeTracking/TimeEntry';

type Props = {
  deletingEntry: TaskTimeEntry | undefined;
  refresh: () => void;
  onClose: () => void;
};

export const DeleteTimeEntryModal = ({ deletingEntry, refresh, onClose }: Props) => {
  const { apiCall: deleteEntryApiCall } = useEvolveDelete(`shop/task/timeEntry/:taskTimeEntryId`);

  return (
    <VariableTrackingModal
      onConfirm={async ({ taskTimeEntryId }) => {
        await deleteEntryApiCall({
          url: `shop/task/timeEntry/${taskTimeEntryId}`,
        }).then(() => {
          notifications.show({
            title: 'Successfully deleted',
            message: `Deleted time entry for ${validateUserNameOrEmail(deletingEntry?.user)}.`,
            color: 'green',
          });
          refresh();
        });
      }}
      variable={deletingEntry}
      onClose={onClose}
      title="Delete time entry"
      confirmationText="Delete"
    >
      {(entry) => (
        <>
          <Text>
            Are you sure you want to delete this time entry for member <b>{validateUserNameOrEmail(entry.user)}</b>?
          </Text>
          <Card mt="xs" withBorder shadow="xs">
            <TimeEntry entry={entry} />
          </Card>
        </>
      )}
    </VariableTrackingModal>
  );
};
